import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from 'tss-react/mui';

// A small tinted label with a dot, for an on/off state in a list.

const useStyles = makeStyles()((theme) => ({
  pill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "2px 10px 2px 8px",
    borderRadius: 12,
    fontSize: 12.5,
    fontWeight: 500,
    lineHeight: 1.6,
    whiteSpace: "nowrap",
  },
  dot: {
    width: 7,
    height: 7,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
  on: {
    color: "#1f8f4a",
    backgroundColor: "rgba(46, 158, 85, 0.12)",
  },
  off: {
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.action.hover,
  },
}));

const StatusPill = ({ on, onLabel = "Active", offLabel = "Inactive" }) => {
  const { classes, cx } = useStyles();
  return (
    <span className={cx(classes.pill, on ? classes.on : classes.off)}>
      <span className={classes.dot} />
      {on ? onLabel : offLabel}
    </span>
  );
};

StatusPill.propTypes = {
  on: PropTypes.bool,
  onLabel: PropTypes.string,
  offLabel: PropTypes.string,
};

export default StatusPill;
